export enum EScrollEventBlockId {
  alfaLeasingPageBenefits = 'alfaLeasingPageBenefits',
  alfaLeasingPageAffiliation = 'alfaLeasingPageAffiliation',
  alfaLeasingPageStages = 'alfaLeasingPageStages',
  financingOfferForm = 'financingOfferForm',
}
